import React, { useState, useEffect } from "react";
import styles from "./UsersPendingTab.module.css";
import InfoCard from "DreamStream/Shared/InfoCard";
import Card from "shared/Card";
import ConfirmationModal from "DreamStream/Shared/ConfirmationModal";
import PendingUsersList from "./PendingUsersList";
import CreateAllModal from "./CreateAllModal";
import SyncErrorsModal from "DreamStream/Shared/SyncErrorsModal";
import { useUsersData } from "../useUsersData";

// const postList = [
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
//   {
//     name: "IBO First Name and Last Name",
//     iboNum: "0000000000",
//     pin: "Diamond",
//     premierSince: "2022-12-14T05",
//   },
// ];

const errorList = [
  {
    timestamp: "2022-12-14T05:07:44.419Z",
    description:
      "wwgId: 153024 | Step 4: Verify DreamStream Account (MAXIMUM ATTEMPTS REACHED)",
    _id: "63995a2091e4418a7dd351e6",
  },
  {
    timestamp: "2022-12-14T05:07:44.419Z",
    description:
      "wwgId: 153024 | Step 4: Verify DreamStream Account (MAXIMUM ATTEMPTS REACHED)",
    _id: "63995a2091e4418a7dd351e6",
  },
  {
    timestamp: "2022-12-14T05:08:36.714Z",
    description:
      "wwgId: 191260 | Step 3: Add to Organizations & Groups (MAXIMUM ATTEMPTS REACHED)",
    _id: "63995a5491e4418a7dda5f59",
  },
  {
    timestamp: "2022-12-14T05:09:15.303Z",
    description:
      "wwgId: 217033 | Step 3: Add to Organizations & Groups (MAXIMUM ATTEMPTS REACHED)",
    _id: "63995a7b91e4418a7ddfe146",
  },
  {
    timestamp: "2022-12-14T05:10:39.738Z",
    description:
      "wwgId: 535028 | Step 5: Send DreamStream Invite Email (MAXIMUM ATTEMPTS REACHED)",
    _id: "63995acf91e4418a7dedb4a9",
  },
];

/**
 * Content in all users pending page.
 */

export function UsersPendingTab() {
  const [createAllModalOpen, setCreateAllModalOpen] = useState(false);
  const [runSyncModalOpen, setRunSyncModalOpen] = useState(false);
  const [syncErrorModalOpen, setSyncErrorModalOpen] = useState(false);

  const handleCreate = () => {
    setCreateAllModalOpen(true);
  };

  // TRY
  const { data, status } = useUsersData("users");

  const [usersData, setUsersData] = useState([]);

  useEffect(() => {
    if (status === "success") {
      setUsersData([...data]);
    }
  }, [data, status]);

  // END TRY

  return (
    <>
      <div className={styles.container}>
        <div className={styles.infoCardContainer}>
          <InfoCard
            body=""
            btnName="CREATE"
            footer=""
            header="CREATE ALL MISSING PREMIER ACCOUNTS"
            onClick={handleCreate}
          />

          <InfoCard
            body=""
            btnName="VIEW"
            footer=""
            header="SYNC RESULTS"
            onClick={() => {
              setSyncErrorModalOpen(true);
            }}
          />

          <InfoCard
            body="10/18/2022 12:01 AM"
            btnName="SYNC"
            footer="Next Sync: 11/18/2022 12:01 AM"
            header="TIME OF LAST GLOBAL SYNC"
            onClick={() => {
              setRunSyncModalOpen(true);
            }}
          />
        </div>

        <Card className={styles.cardContainer}>
          <div className={styles.cardHeader}>
            <h5 className={styles.title}>PENDING USERS</h5>
            <div className={styles.hr} />
          </div>
          <div className={styles.usersDiv}>
            <p className={styles.activeText}>
              Active Premier members who don't yet have a Dreamstream Account.
            </p>
          </div>
          <div className={styles.postsDiv}>
            {status === "success" ? (
              <>
                <PendingUsersList posts={usersData} />
              </>
            ) : status === "loading" ? (
              <div className={styles.loadMessage}>Loading data...</div>
            ) : (
              <div className={styles.loadMessage}>Error fetching data</div>
            )}
          </div>
        </Card>

        <CreateAllModal
          isOpen={createAllModalOpen}
          onClose={() => setCreateAllModalOpen(false)}
          onClick={() => alert("Create all clicked")}
        />

        <SyncErrorsModal
          isOpen={syncErrorModalOpen}
          title="PENDING USER SYNC"
          errors={errorList}
          onClose={() => setSyncErrorModalOpen(false)}
        />

        <ConfirmationModal
          header="RUN GLOBAL SYNC"
          isOpen={runSyncModalOpen}
          description="Sync every user in the Dreamstream database. The last global sync was run [MM/DD/YYYY at HH:MM AM]."
          btnName="RUN SYNC"
          onClose={() => setRunSyncModalOpen(false)}
          onClick={() => alert("Run Sync clicked")}
        />
      </div>
    </>
  );
}
